import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pt from './pt';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'pt',
  fallbackLocale: 'pt',
  messages: { pt },
});

export default i18n;
